module.exports = __webpack_public_path__ + "static/media/shimakaze-win.c8f6bd90.png";